import Immutable from 'immutable';

import ErrorData from 'sharedreact/data/ErrorData';
import type Filter from 'sharedreact/data/Filter';
import GroupAndCount from 'sharedreact/data/GroupAndCount';
import type SortOrder from 'sharedreact/data/SortOrder';
import type { RangeType } from 'sharedreact/stores/generic/Type';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';
import FilterSupport from 'sharedreact/utils/FilterSupport';

import AuditRecord from 'sharedreact/data/AuditRecord';

type OnFetchSuccess = (
  range: RangeType,
  totalCount: number,
  items: Immutable.List<AuditRecord>,
  countPerGroup: Immutable.List<GroupAndCount>,
  filter: Filter,
  advancedFilter: Filter,
  groupBy: SortOrder,
  sortOrder: SortOrder) => void;

type OnError = (error: ErrorData) => void;

const _filterKeywords = ['name', 'modificationdate'];

function fetch (
  range: RangeType,
  filter: Filter,
  advancedFilter: Filter,
  groupBy: SortOrder,
  sortOrder: SortOrder,
  isInitialFetch: boolean,
  onSuccess: OnFetchSuccess,
  onError: OnError
) {
  const expandedFilter: Filter = FilterSupport.expand(
    filter,
    _filterKeywords
  );

  const expandedAdvancedFilter: Filter = FilterSupport.expand(
    advancedFilter,
    _filterKeywords
  );

  ConnectionSupport.post(
    'getAuditRecords',
    {
      range: range,
      filter: expandedFilter,
      advancedFilter: expandedAdvancedFilter,
      groupBy: groupBy,
      sortOrder: sortOrder
    },
    (data) => onSuccess(
      data.range,
        data.totalCount,
        Immutable.List(data.items.map((auditRecord: any) => AuditRecord.fromJS(auditRecord))),
        Immutable.List(data.countPerGroup.map(GroupAndCount.fromJS)),
        filter,
        advancedFilter,
        groupBy,
        sortOrder
    ),
    onError
  );
}

export default {
  fetch
};
